import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './assign-control-dialog.controller';
import template from './assign-control-dialog.html';
import nameMessagesTpl from './name.messages.html';
import control from '../../controlAdministration/control';
import editControlDialog from '../../controlAdministration/dialog.editControlDialog';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    risk,
    controls,
  }) {
    return {
      controller,
      controllerAs: 'assignControlDialogVM',
      locals: {
        risk,
        controls,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.riskAdministration.assignControlDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  riskDataService,
  controlDataService,
  controlSharedModelService,
  editControlDialog,
  copy,
  alerts,
  control
])
  .service('assignControlDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.admin.riskAdministration.assignControlDialog created');
